import { render, staticRenderFns } from "./fapq.vue?vue&type=template&id=2cdecd2a&scoped=true&"
import script from "./fapq.vue?vue&type=script&lang=js&"
export * from "./fapq.vue?vue&type=script&lang=js&"
import style0 from "./fapq.vue?vue&type=style&index=0&id=2cdecd2a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cdecd2a",
  null
  
)

export default component.exports